import './App.css';
import BgcForm from './components/BgcForm';
import { BlinkBgc } from './components/BlinkBgc';

function App() {
  return (
    <div className="App">
      <BgcForm/>
    </div>
  );
}

export default App;
